var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodingChallengeTimeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_1884)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_415_1884)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4993 2.23327C7.06753 2.23327 1.85352 7.44728 1.85352 13.8791C1.85352 20.3109 7.06753 25.5249 13.4993 25.5249C19.9312 25.5249 25.1452 20.3109 25.1452 13.8791C25.1452 7.44728 19.9312 2.23327 13.4993 2.23327Z",
    fill: "#00EDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96525 2.59689C7.31565 2.31657 7.37246 1.80527 7.09214 1.45487C6.81182 1.10447 6.30052 1.04766 5.95012 1.32798L3.24178 3.49464C2.89138 3.77496 2.83457 4.28626 3.11489 4.63666C3.39521 4.98706 3.90651 5.04388 4.25691 4.76356L6.96525 2.59689Z",
    fill: "#00EDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0486 1.32798C20.6982 1.04766 20.1869 1.10447 19.9066 1.45487C19.6262 1.80527 19.683 2.31657 20.0334 2.59689L22.7418 4.76356C23.0922 5.04388 23.6035 4.98706 23.8838 4.63666C24.1641 4.28626 24.1073 3.77496 23.7569 3.49464L21.0486 1.32798Z",
    fill: "#00EDD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72446 4.94901L3.11489 4.63666L2.72446 4.94901C3.17728 5.51504 4.00323 5.60681 4.56926 5.15399L7.27759 2.98732C7.84362 2.5345 7.9354 1.70855 7.48257 1.14252C7.02975 0.576488 6.2038 0.484717 5.63777 0.937542L5.95012 1.32798L5.63777 0.937542L2.92944 3.10421C2.3634 3.55703 2.27163 4.38298 2.72446 4.94901ZM13.4993 1.73327C6.79139 1.73327 1.35352 7.17114 1.35352 13.8791C1.35352 20.5871 6.79139 26.0249 13.4993 26.0249C20.2073 26.0249 25.6452 20.5871 25.6452 13.8791C25.6452 7.17114 20.2073 1.73327 13.4993 1.73327ZM21.3609 0.937542C20.7949 0.484717 19.9689 0.576488 19.5161 1.14252V1.14252C19.0633 1.70855 19.1551 2.5345 19.7211 2.98732L22.4294 5.15399C22.9955 5.60681 23.8214 5.51504 24.2742 4.94901C24.7271 4.38298 24.6353 3.55703 24.0693 3.10421L21.3609 0.937542Z",
    stroke: "url(#paint0_linear_415_1884)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_415_1884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3112 9.5459C14.3112 9.09717 13.9474 8.7334 13.4987 8.7334C13.05 8.7334 12.6862 9.09717 12.6862 9.5459V14.1022C12.6862 14.4476 12.5543 14.7799 12.3173 15.0312L10.7409 16.7033C10.433 17.0298 10.4482 17.544 10.7747 17.8518C11.1012 18.1597 11.6154 18.1445 11.9232 17.818L13.4997 16.1459C14.0209 15.5931 14.3112 14.862 14.3112 14.1022V9.5459Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_415_1884",
    x: -23.1465,
    y: -23.8501,
    width: 73.291,
    height: 74.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_415_1884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_415_1884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_415_1884",
    x: 7.51953,
    y: 5.7334,
    width: 19.791,
    height: 25.3398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_415_1884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_415_1884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_1884",
    x1: 1.85352,
    y1: 1.1499,
    x2: 26.2146,
    y2: 24.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_1884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingChallengeTimeCircle);
export default __webpack_public_path__ + "static/media/CodingChallengeTimeCircle.40fcff2c580533498bf5acb7802bb6d9.svg";
export { ForwardRef as ReactComponent };